import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1344da6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "pb-3" }
const _hoisted_4 = { class: "fw-bold d-flex align-items-center text-dark" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "row pb-2" }
const _hoisted_7 = { class: "col-lg-6 pb-2" }
const _hoisted_8 = { class: "col-lg-6 pb-2" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-lg-6 pb-2" }
const _hoisted_11 = { class: "col-lg-6 pb-2" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-6 pb-2" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-6 pb-2" }
const _hoisted_16 = { class: "col-lg-6 pb-2" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-lg-6 pb-2" }
const _hoisted_19 = { class: "col-lg-6 pb-2" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-lg-6 pb-2" }
const _hoisted_22 = { class: "col-lg-6 pb-2" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-lg-6 pb-2" }
const _hoisted_25 = { class: "col-lg-6 pb-2" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-lg-6 pb-2" }
const _hoisted_28 = { class: "col-lg-6 pb-2" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-lg-6 pb-2" }
const _hoisted_31 = { class: "col-lg-6 pb-2" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-lg-6 pb-2" }
const _hoisted_34 = { class: "col-lg-6 pb-2" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-lg-6 pb-2" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "d-flex align-items-center" }
const _hoisted_39 = { class: "row mb-7" }
const _hoisted_40 = { style: {"color":"#409eff","font-size":"0.9rem"} }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-lg-6" }
const _hoisted_43 = { class: "row mb-7" }
const _hoisted_44 = { style: {"color":"#409eff","font-size":"0.9rem"} }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-lg-6" }
const _hoisted_47 = { class: "row mb-7" }
const _hoisted_48 = { style: {"color":"#409eff","font-size":"0.9rem"} }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "d-flex align-items-center" }
const _hoisted_51 = { style: {"font-size":"0.9rem"} }
const _hoisted_52 = { class: "d-flex align-items-center" }
const _hoisted_53 = { class: "row mb-7" }
const _hoisted_54 = {
  href: "https://www.google.com/",
  target: "_blank",
  rel: "noopener noreferrer",
  style: {"color":"#409eff","text-decoration":"underline"}
}

import { ref, inject, onMounted, watch } from "vue";
import { useStore } from "@/store";
import { getRegionCodes } from "@/core/data/phonesData";
import i18n from "@/core/plugins/i18n";
import { occupations } from "@/core/types/jp/verificationInfo";
import { Core, Address } from "@/core/data/jpAddressGetter";

export default /*#__PURE__*/_defineComponent({
  __name: 'VerificationInfoJp',
  setup(__props) {

const postalCode = ref<string>("");

const handlePostalCodeChange = async (event: Event) => {
  const input = event.target as HTMLInputElement;
  postalCode.value = input.value;
  if (postalCode.value.length >= 7) {
    new Core(postalCode.value, (address: Address) => {
      formData.value.region = address.region || "";
      formData.value.village = address.l || "";
      if (address.o) {
        formData.value.town = address.m + " " + address.o || "";
      } else {
        formData.value.town = address.m || "";
      }
    });
  } else {
    formData.value.region = "";
    formData.value.village = "";
    formData.value.town = "";
  }
};

const t = i18n.global.t;
const store = useStore();
const user = store.state.AuthModule.user;
const items = inject<any>("items");
const formData = inject<any>("formData");
const isSubmitting = inject<any>("isSubmitting");
const regionCodes = ref<any>(getRegionCodes());
const item = ref<any>(items?.value?.data?.info || {});
const citizenSelect = ref<any>(false);
const pepsSelect = ref<any>(false);
const ohterCitizen = ref<any>("");

const citizenToggle = (value: boolean) => {
  citizenSelect.value = value;
  if (value == true) {
    formData.value.citizen = null;
  } else {
    formData.value.citizen = "jp";
    formData.value.otherCitizen = null;
  }
};

const pepsToggle = (value: boolean) => {
  pepsSelect.value = value;
  if (value == true) {
    formData.value.declarationRegardingForeignPeps = null;
  } else {
    formData.value.declarationRegardingForeignPeps = "no";
    formData.value.otherPeps = "";
  }
};

watch(
  () => formData.value.birthday,
  (newBirthday) => {
    if (newBirthday) {
      const today = new Date();
      const birthDate = new Date(newBirthday);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      // Adjust age if the birthday hasn't occurred yet this year
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      formData.value.age = age.toString(); // Update age
    } else {
      formData.value.age = ""; // Reset age if birthday is cleared
    }
  }
);

onMounted(() => {
  formData.value = item.value;
  formData.value.email = user.email;
  formData.value.phone = user.phoneNumber;
  formData.value.firstName = user.firstName;
  formData.value.lastName = user.lastName;

  if (item.value.citizen == null) {
    item.value.citizen = "jp";
  } else if (item.value.citizen !== "jp") {
    citizenSelect.value = true;
  } else {
    citizenSelect.value = false;
  }

  if (item.value.declarationRegardingForeignPeps == null) {
    item.value.declarationRegardingForeignPeps = "no";
  } else if (item.value.declarationRegardingForeignPeps !== "no") {
    pepsSelect.value = true;
  } else {
    pepsSelect.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("title.personalInfo")) + " (" + _toDisplayString(_unref(user).email) + ") ", 1)
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.lastName'),
            prop: "lastName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).lastName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).lastName) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.firstName'),
            prop: "firstName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).firstName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).firstName) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.nativeNameLast'),
            prop: "nativeNameLast"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).nativeNameLast,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).nativeNameLast) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.nativeNameFirst'),
            prop: "nativeNameFirst"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).nativeNameFirst,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).nativeNameFirst) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.gender'),
            prop: "gender"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _unref(formData).gender,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).gender) = $event)),
                size: "large",
                disabled: _unref(isSubmitting)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_button, {
                    label: "0",
                    value: "0"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("fields.male")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio_button, {
                    label: "1",
                    value: "1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("fields.female")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.birthdate'),
            prop: "birthday"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _unref(formData).birthday,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).birthday) = $event)),
                type: "date",
                size: "large",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD",
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.age'),
            prop: "age"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).age,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formData).age) = $event)),
                disabled: ""
              }, {
                append: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("fields.yearsOld")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.postalCode'),
            onInput: handlePostalCodeChange,
            prop: "postalCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).postalCode,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formData).postalCode) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.region'),
            prop: "region"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).region,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formData).region) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.village'),
            prop: "village"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).village,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(formData).village) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.town'),
            prop: "town"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).town,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(formData).town) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.street'),
            prop: "street"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).street,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(formData).street) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.buildingNumber'),
            prop: "buildingNumber"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).buildingNumber,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(formData).buildingNumber) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.email'),
            prop: "email"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).email,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(formData).email) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.phone'),
            prop: "phone"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).phone,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(formData).phone) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.occupation'),
            prop: "occupation"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _unref(formData).occupation,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(formData).occupation) = $event)),
                disabled: _unref(isSubmitting),
                placeholder: _ctx.$t('fields.select')
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(occupations), (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.companyName'),
            prop: "companyName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).companyName,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(formData).companyName) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_el_form_item, {
            label: 
              _ctx.$t('fields.affiliatedDepartment') +
              ' (' +
              _ctx.$t('fields.optional') +
              ')'
            ,
            prop: "affiliatedDepartment"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).affiliatedDepartment,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(formData).affiliatedDepartment) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_el_form_item, {
            label: 
              _ctx.$t('fields.affiliatedPosition') +
              ' (' +
              _ctx.$t('fields.optional') +
              ')'
            ,
            prop: "affiliatedPosition"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).affiliatedPosition,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(formData).affiliatedPosition) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.companyPhone'),
            prop: "companyPhone"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(formData).companyPhone,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(formData).companyPhone) = $event)),
                disabled: _unref(isSubmitting)
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.nationalityInformation'),
            required: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _unref(formData).citizen,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(formData).citizen) = $event)),
                disabled: _unref(isSubmitting)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    value: "jp",
                    label: "jp",
                    size: "large",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (citizenToggle(false)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("fields.japanese")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    value: true,
                    label: true,
                    size: "large",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (citizenToggle(true))),
                    disabled: _unref(isSubmitting)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("fields.otherThanJapan")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          (citizenSelect.value)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: " ",
                class: "ms-2",
                prop: "otherCitizen"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(formData).otherCitizen,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(formData).otherCitizen) = $event)),
                    placeholder: _ctx.$t('tip.selectCountry'),
                    disabled: _unref(isSubmitting)
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionCodes.value, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: index,
                          label: item.name,
                          value: item.code
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("tip.jpCitizenTip")), 1)
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.countryOfResidence'),
            prop: "countryOfResidence"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _unref(formData).countryOfResidence,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(formData).countryOfResidence) = $event)),
                disabled: _unref(isSubmitting)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    value: "jp",
                    label: "jp",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("fields.japan")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    value: true,
                    label: true,
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("fields.residenceThanJapan")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t("tip.jpResidenceTip")), 1)
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.usTaxLiability'),
            prop: "usTax"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _unref(formData).usTax,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(formData).usTax) = $event)),
                disabled: _unref(isSubmitting),
                class: "usTax"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    value: false,
                    label: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("fields.usTaxOne")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    value: true,
                    label: true
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("fields.usTaxTwo")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("tip.jpTaxTip")), 1)
      ]),
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.declarationRegardingForeignPeps'),
            prop: "declarationRegardingForeignPeps"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t("tip.jpPrepTip")), 1),
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _unref(formData).declarationRegardingForeignPeps,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(formData).declarationRegardingForeignPeps) = $event)),
                    disabled: _unref(isSubmitting)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, {
                        value: "no",
                        label: "no",
                        size: "large",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (pepsToggle(false)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("fields.no")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, {
                        value: true,
                        label: true,
                        size: "large",
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (pepsToggle(true))),
                        disabled: _unref(isSubmitting)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("fields.yes")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"]),
                  (pepsSelect.value)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: " ",
                        class: "ms-4 pb-2 lh-0 prep",
                        prop: "otherPeps"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(formData).otherPeps,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(formData).otherPeps) = $event)),
                            disabled: _unref(isSubmitting),
                            placeholder: _ctx.$t('tip.pleaseBeSpecific')
                          }, null, 8, ["modelValue", "disabled", "placeholder"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("a", _hoisted_54, _toDisplayString(_ctx.$t("fields.foreignPeps")), 1)
      ])
    ])
  ]))
}
}

})